"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iosPlatforms = void 0;
exports.iosPlatforms = Object.freeze({
    IPAD: 'iPad',
    IPHONE: 'iPhone',
    IPOD: 'iPod'
});
